"use strict";

import { addTimesToResponse } from "../../utils/videoTimes";

export default class VideoContentCtrl {
  static get UID() {
    return "videoContentCtrl";
  }

  constructor($stateParams, $sce, updateFac, $filter) {
    "ngInject";

    Object.assign(this, { $stateParams, $sce, updateFac, $filter });

    var currentlyPlayingFile;

    this.video = {};
    this.playerConfig = {
      preload: "none",
      plugins: {
        controls: {
          autoHide: true,
          autoHideTime: 5000,
        },
      },
    };

    updateFac.getUpdate(this.$stateParams.updateId).then((response) => {
      this.video = response.data.data;
      this.videoFiles = this.video.videos;

      this.showVideoFileLabels = Object.keys(this.videoFiles).length > 1;

      var highEncoding = 0;
      Object.keys(this.videoFiles).forEach(function (ele, idx) {
        highEncoding = ele > highEncoding && ele !== "t" ? ele : highEncoding;
      });

      var file = this.videoFiles[highEncoding].files[0];
      this.playerConfig.sources = [
        {
          src: $sce.trustAsResourceUrl(file.download_link),
          type: "video/" + file.format,
        },
      ];
      this.currentlyPlayingFile = file.name.toLowerCase();

      // setup the image content
      this.video.shownImages = [];
      for (var x = 0; x < 6; x++) {
        this.video.shownImages.push(this.video.images[x]);
      }

      updateFac
        .getRelatedUpdates(this.$stateParams.updateId, 3)
        .then((response) => {
          this.relatedVideos = addTimesToResponse(response, this.$filter);
        });
    });
  }

  activeVideoFile(file) {
    if (!this.currentlyPlayingFile && file.part.toLowerCase() === "t") {
      return true;
    } else if (file.name.toLowerCase() === this.currentlyPlayingFile) {
      return true;
    }

    return false;
  }

  playFile(file) {
    this.currentlyPlayingFile = file.name.toLowerCase();
    this.playerConfig.sources = [
      {
        src: this.$sce.trustAsResourceUrl(file.download_link),
        type: "video/" + file.format,
      },
    ];
    this.playerConfig.width = file.width || "100%";
    this.playerConfig.height = file.height || "100%";
  }

  // load more images onto array for infinite scroll
  getMoreImages() {
    if (!this.video || !this.video.shownImages) {
      return;
    }

    var start = this.video.shownImages.length || 0;
    var end = this.video.images.length;

    for (var x = start; x <= start + 5 && x <= end; x++) {
      this.video.shownImages.push(this.video.images[x]);
    }
  }
}



// WEBPACK FOOTER //
// ./~/site_core/src/features/videoContent/videoContentCtrl.js